var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center"},[_c('chart-base',{ref:"chartsales",attrs:{"height":700,"width":800,"chart-type":"bar","chartData":_vm.chartData,"chartOptions":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }